.fabButton {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.fabButton:hover {
  transform: scale(1.1) !important;
  opacity:  1 !important;
  box-shadow: 0 8px 24px rgba(25, 118, 210, 0.6) !important;
}

.fabButton:active {
  transform: scale(0.95);
}

.quickCreateMenu {
  animation: slideUp 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(10px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
